<form id="share-certificates-form" #sharedCertForm="ngForm" class="bl-font-color--base">
  <div class="flexbox-format" *ngFor="let item of beneficiaryList;let i = index;">
    <div class="bl-margin-bottom--16 inline">
      <label [for]="field.id +'-'+ i" class="bl-label bl-required bl-font-weight--800 bl-font-size--14">Beneficiary
        {{item.acutalIndex+1}} - {{item.type.value}}</label>
      <input #allocation="ngModel" [(ngModel)]="item.allocation.value" [id]="field.id +'-'+ i" class="bl-input"
        [attr.data-automation-id]="field.automationId +'-'+ i"
        name="allocation-{{i}}" required (blur)="focused = false; processMask($event,item.allocation,false)"
        (focus)="focused = true; processMask($event,item.allocation);" (cut)="processMask($event,item.allocation)"
        (paste)="processMask($event,item.allocation)" (input)="processMask($event,item.allocation)"
        (keyup)="processMask($event,item.allocation)" (mouseup)="processMask($event,item.allocation)"
        (change)="onChange($event,item.allocation,item.acutalIndex)" aria-errormessage="error-beneficiary" />
      <cu-validation-messages fieldId="beneficiary" fieldLabel="Beneficiary" *ngIf="allocation.invalid && allocation.dirty" [failedValidations]="validation">
      </cu-validation-messages>
    </div>
  </div>
  <div *ngIf="beneficiaryList && beneficiaryList.length > 0 && totalAllocation ">
    <p id="total-allocation-label" class="bl-label bl-font-weight--800 bl-font-size--14 bl-margin-bottom--4">Total {{beneficiaryList[0].type.value}} Allocation:</p>
    <p class="bl-margin-bottom--0" aria-labelledby="total-allocation-label">{{totalAllocation? totalAllocation+"%":''}}</p>
  </div>
  <div class="bl-error-msg bl-margin-top--16 bl-font-size--16" *ngIf="totalAllocation&&allocationLeft > 0">
    <p id="left-allocation-label" class="bl-label bl-font-weight--800 bl-margin-bottom--4">% left to allocate:</p>
    <p class="bl-margin-bottom--0" aria-labelledby="left-allocation-label">{{allocationLeft}} %</p>
  </div>
  <div class="bl-error-msg bl-margin-top--16 bl-font-size--16" *ngIf="totalAllocation&&allocationMore > 0">
    <p id="over-allocation-label" class="bl-label bl-font-weight--800 bl-margin-bottom--4">% over allocation:</p>
    <p class="bl-margin-bottom--0" aria-labelledby="over-allocation-label">{{allocationMore}} %</p>
  </div>
</form>
